import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=1b5d6662&scoped=true"
import script from "./InputMoney.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputMoney.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=1b5d6662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d6662",
  null
  
)

export default component.exports